import {faStar} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import React from 'react'

interface MemberRateBadgeProps {
  className?: string
}

const MemberRateBadge: React.FC<MemberRateBadgeProps> = ({className}) => {
  return (
    <div
      className={clsx(
        'badge badge-outline badge-accent rounded-full text-xs',
        className
      )}
    >
      <FontAwesomeIcon icon={faStar} className="mr-1" title="Member rate" />
      <span>Member Rate</span>
    </div>
  )
}

export default MemberRateBadge
